import React from 'react';

/**
 * Single <option> for the "Select Employee" dropdown in the Add Leave modal.
 * Extracted + memoized per the perf pass, but intentionally NOT virtualized:
 * react-window renders rows as absolutely-positioned divs, which cannot live
 * inside a native <select> (the browser owns and renders its <option> list
 * itself, so there's nothing react-window can attach a virtualized DOM
 * node to). Memoizing the option still avoids re-creating/re-rendering every
 * entry when unrelated parts of the Add Leave modal re-render.
 */
function EmployeeOptionRow({ employee }) {
  return (
    <option value={employee._id}>
      {employee.firstName} {employee.lastName} ({employee.email})
    </option>
  );
}

export default React.memo(EmployeeOptionRow);
